let currentVariantId;
let productData;
let arrayOfSwymCollectionsButtons;
let variantImagesArray;
let selectedVariant = {};
let globalActionArray = [];
let globalListArray = [];
let globalProductsInListArray = [];
let selectCallBackObj = [];
let productURL;
window.eventsAddedToVariantSelectorModal = false;

function customErrorHandling(error) {
    console.error('Error - ', error);
    // _swat.ui.uiRef.showErrorNotification({ message: error });
}

function customSuccessHandling(item) {
    const [title, image] = [`${productData.product.title} - ${selectedVariant.title}`, variantImagesArray[0].src];
    const message = _swat.retailerSettings.Strings.AddWishlistAddSuccess.replace(/{{{?variantName}?}}/g,title);
    const html = `
            <style>
            .swym-notification-success-inner .swym-image{ display: none !important }
            #swym-custom-notification-content { display: flex; align-items: center; cursor: pointer }
            #swym-custom-notification-content #swym-custom-image-container { min-height: 96px; min-width: 96px; max-height: 96px; max-width: 96px; overflow: hidden; background: rgb(var(--color-base-brand-lightest-grey))!important; }
            #swym-custom-notification-content #swym-custom-image-container #swym-custom-image { width: 100%; object-fit: cover; aspect-ratio: 1 / 1; mix-blend-mode: multiply!important }
            .swym-notification-success-inner, .swym-notification-success-inner .swym-details-container .swym-details { padding-block: 0 !important; padding-left: 0 !important }
            #swym-custom-notification-content #swym-custom-title-conatainer { font-family: var(--font-heading-family); padding-inline: 16px 25px; color: #434655; font-size: var(--text-size-xs); font-weight: font-weight: var(--font-weight-normal); letter-spacing: normal !important; line-height: var(--leading-looser) }
            #swym-custom-notification-content #swym-custom-title-conatainer .swym-emphasis { color: rgb(var(--color-base-dark)); display: block; font-weight: var(--font-weight-medium); text-transform: uppercase; }
        </style>
        <div id="swym-custom-notification-content" onclick="_swat.ui.open()">
            <div id="swym-custom-image-container">
                <img id="swym-custom-image" src="${image}" alt="wishlisted product image"/>
            </div>
            <div id="swym-custom-title-conatainer">${message}</div>
        </div>
    `;
    _swat.ui.showSuccessNotification({message: html})
}

function performListAction(event) {
    let listId = event.target.getAttribute("list-id");
    let variantInList = event.target.getAttribute("variantExistsInList") === 'true'; // Convert to boolean

    var product = {
        epi: currentVariantId,
        empi: productData.product.id,
        du: productURL
    };

    function updateGlobalListArray() {
        _swat.fetchLists({
            callbackFn: function (lists) {
                globalListArray = lists;
                globalListArray.forEach((list) => {
                    let listElement = document.querySelector(`.swym-custom-list-button[data-list-id="${list.lid}"]`);
                    if (listElement) {
                        listElement.innerHTML = `${list.lname} (${list.listcontents.length})`;
                    }
                });
            },
            errorFn: function (error) {
                console.error("Error while fetching all Lists", error);
            }
        });
    }

    if (variantInList) {
        // Remove product
        let onSuccess = function (deletedProduct) {
            event.target.setAttribute("variantexistsinlist", "false");
            event.target.innerHTML = "Add";
            updateGlobalListArray(); // Update global list array after removal
            generateUpdateMessage();
        };

        let onError = function (error) {
            console.error("Error while deleting the Product", error);
        };

        _swat.deleteFromList(listId, product, onSuccess, onError);

    } else {
        // Add product
        let onSuccess = function (addedListItem) {
            event.target.setAttribute("variantexistsinlist", "true");
            event.target.innerHTML = "Remove";
            let listName = event.target.getAttribute("list-name");
            updateGlobalListArray();
            let updateMessage = `${productData.product.title} has been successfully added to ${listName}`;
            customSuccessHandling(updateMessage);
        };

        let onError = function (error) {
            console.error("Error while adding the Product to the List", error);
        };

        _swat.addToList(listId, product, onSuccess, onError);
    }
}

function onSwymLoadCallback(swat) {
    const currentLanguage = swat.retailerSettings.UI.Language ? swat.retailerSettings.UI.Language : 'english';
    const swymCollectionsModal = document.getElementById("swym-custom-collections-modal-background");
    const desktopModalTitle = document.getElementById("swym-custom-modal-title");
    const multipleListParentContainer = document.getElementById("swym-custom-multiple-list-parent-container");
    const selectPreferenceText = document.getElementById("swym-custom-select-preference-text");
    const selectListsText = document.getElementById("swym-custom-select-wishlists-text");
    const createListGuideText = document.getElementById("swym-list-guide-text");
    const webpageBody = document.querySelector("body");
    const modalCloseButton = document.getElementById("swym-custom-modal-close");
    const mobileModalTitle = document.getElementById("swym-custom-mobile-title");
    const createListModalTitle = document.getElementById("swym-create-list-title");
    const variantSelectionContainer = document.getElementById("swym-custom-variant-selector-container");
    const addToWishlistButton = document.getElementById("swym-custom-add-to-wishlist-button");
    const isSingleWishlist = !swat.retailerSettings.Wishlist.EnableCollections;
    const listIdContainer = document.getElementById("swym-custom-list-id-container");
    const createListButton = document.getElementById("swym-custom-create-list-button");
    const confirmListNameButton = document.getElementById("swym-custom-confirm-list-button");
    const createListContainer = document.getElementById("swym-custom-backdrop");
    const cancelListCreationButton = document.getElementById("swym-custom-notconfirm-list-button");
    const listNameInput = document.getElementById("swym-custom-new-list-name-input");
    const variantImage = document.getElementById("swym-custom-primary-image");
    const vendorTitle = document.getElementById("swym-custom-vendor-title");
    const productTitle = document.getElementById("swym-custom-product-title");
    const price = document.getElementById("swym-custom-variant-price");
    const variantTitle = document.getElementById("swym-custom-variant-title");
    const imgBlobContainer = document.getElementById("swym-custom-image-blob-container");
    const imageSliderContainer = document.getElementById("swym-custom-images-slide-container");
    const prevButton = document.getElementById("swym-custom-slide-arrow-prev");
    const nextButton = document.getElementById("swym-custom-slide-arrow-next");

    const translationsObject = {
        'english': {
            defaultWishlistTitle: themeSettings.defaultWishlistTitle,
            desktopModalTitle: themeSettings.desktopModalTitle,
            addedToSingleList: themeSettings.addedToSingleList,
            addedToMultipleLists: themeSettings.addedToMultipleLists,
            selectPreferenceText: themeSettings.selectPreferenceText,
            selectWishlistText: themeSettings.selectWishlistText,
            createListButtonText: themeSettings.createListButtonText,
            createListInputPlaceHolder: themeSettings.createListInputPlaceHolder,
            addToWishlistTextNoListSelected: themeSettings.addToWishlistTextNoListSelected,
            addToWishlistTextAddState: themeSettings.addToWishlistTextAddState,
            addToWishlistTextUpdateState: themeSettings.addToWishlistTextUpdateState,
            singleWishlistButtonAddText: themeSettings.singleWishlistButtonAddText,
            singleWishlistButtonRemoveText: themeSettings.singleWishlistButtonRemoveText,
            createListModalTitle: themeSettings.createListModalTitle,
            createListGuideText: themeSettings.createListGuideText,
            confirmNewListButtonText: themeSettings.confirmNewListButtonText,
            notificationAddText: themeSettings.notificationAddText,
            notificationRemoveText: themeSettings.notificationRemoveText,
            notificationUpdateText: themeSettings.notificationUpdateText,
            listNameError: themeSettings.listNameError,
            listNameNotUniqueError: themeSettings.listNameNotUniqueError,
            listLimitErrorMessage: themeSettings.listLimitErrorMessage,
        }
    }

    const currentLanguageOption = translationsObject[currentLanguage] ? translationsObject[currentLanguage] : translationsObject['english'];
    const defaultWishlistTitle = currentLanguageOption.defaultWishlistTitle;

    (function addTextToModal() {
        desktopModalTitle.textContent = window.swymVsDesktopTitle;
        selectPreferenceText.textContent = window.swymVsPopupSelectPreferencesText;
    })();

    function debounce_leading(func, timeout = 300) {
        let timer;
        return (...args) => {
            if (!timer) {
                func.apply(this, args);
            }
            clearTimeout(timer);
            timer = setTimeout(() => {
                timer = undefined;
            }, timeout);
        };
    }

    async function persistWishlistButtonsState() {
        if(window.currentActiveListId){
            return new Promise((resolve, reject) => {
                let onSuccess = function (list) {
                    globalListArray = [list.list];
                    list.items.forEach((product) => {
                        let productId = +product.empi;
                        let buttonsToFill = document.querySelectorAll(`.swym-wishlist-button--${productId}`);
                        buttonsToFill.forEach((buttonToFill) => {
                            if (buttonToFill && buttonToFill.dataset.hotspotWishlistButton !== 'true' && !buttonToFill.classList.contains('swym-added')) {
                                SwymUtils.addClass(buttonToFill, "swym-added");
                            }
                        })
                    });
                    resolve();
                };

                let onError = function (error) {
                    console.error("Error while fetching single list - ", error);
                    reject(error);
                };

                swat.fetchListDetails(
                    { lid : window.currentActiveListId },
                    onSuccess,
                    onError,
                );
            });
        }
    }

    async function handleRemoveFromWishlistButtonState(productId) {
        try {
            await persistWishlistButtonsState();
            const productIdExistsInSomeList = globalListArray.some((list) =>
                list.listcontents.some((product) => product.empi === productId)
            );

            if (!productIdExistsInSomeList) {
                const buttonsToUnFill = document.querySelectorAll(`.swym-wishlist-button--${productId}`);
                buttonsToUnFill.forEach((buttonToUnFill) => {
                    if (buttonToUnFill && buttonToUnFill.dataset.hotspotWishlistButton !== 'true') {
                        SwymUtils.removeClass(buttonToUnFill, "swym-added");
                    }
                })
            }
        } catch (error) {
            console.error("An error occurred:", error);
        }
    }

    function handleAddedToWishlistButtonState(productId) {
        const buttonsToFill = document.querySelectorAll(`.swym-wishlist-button--${productId}`);
        buttonsToFill.forEach((buttonToFill) => {
            if (buttonToFill && buttonToFill.dataset.hotspotWishlistButton !== 'true' && !buttonToFill.classList.contains('swym-added')) {
                SwymUtils.addClass(buttonToFill, "swym-added");
            }
        })
    }

    swat.evtLayer.addEventListener(swat.JSEvents.removedFromWishlist, function (data) {
        // product-level refresh
        let productId = data.detail.d.empi;
        handleRemoveFromWishlistButtonState(productId);

        // variant-level refresh for hotspot buttons
        const variantId = data.detail.d.epi;
        if (variantId) {
            const hotspotButtons = document.querySelectorAll(`.swym-wishlist-collection-btn[data-hotspot-wishlist-button="true"][data-variant-id="${variantId}"]`);
            hotspotButtons.forEach((btn) => setWishlistButtonState(btn, false));
        }

        setTimeout(function(){
            document.dispatchEvent(new CustomEvent('swym:refresh-buttons'));
        }, 1000)
    });

    swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, function (data) {
        // product-level refresh
        let productId = data.detail.d.empi;
        handleAddedToWishlistButtonState(productId);

        // variant-level refresh for hotspot buttons
        const variantId = data.detail.d.epi;
        if (variantId) {
            const hotspotButtons = document.querySelectorAll(`.swym-wishlist-collection-btn[data-hotspot-wishlist-button="true"][data-variant-id="${variantId}"]`);
            hotspotButtons.forEach((btn) => setWishlistButtonState(btn, true));
        }

        setTimeout(function(){
            document.dispatchEvent(new CustomEvent('swym:refresh-buttons'));
        }, 1000)
    });

    function showZoomedView(e) {
        const zoomedView = document.createElement('div');
        const zoomedImage = new Image();
        SwymUtils.addClass(zoomedView, 'zoomed-image');
        zoomedImage.src = e.target.src;
        zoomedView.appendChild(zoomedImage);

        const closeButton = document.createElement('button');
        closeButton.setAttribute('aria-label', 'Close zoomed image');
        closeButton.classList.add('swym-zoomed-image-close-button', 'close-button');
        closeButton.innerHTML = '&times;';
        closeButton.addEventListener('click', () => {
            document.body.removeChild(zoomedView);
        });
        zoomedView.appendChild(closeButton);

        document.body.appendChild(zoomedView);

        zoomedView.addEventListener('click', (event) => {
            if (event.target === zoomedView) {
                document.body.removeChild(zoomedView);
            }
        });
    }

    function addImgBlobClickListener(event) {
        const imgBlobSrc = event.target.getAttribute("src");
        const allImgBlobs = document.querySelectorAll("#swym-custom-image-blob");
        variantImage.src = imgBlobSrc;

        allImgBlobs.forEach((imgBlob) => {
            if (imgBlob !== event.target) {
                imgBlob.classList.remove("selected");
            }
        });

        SwymUtils.toggleClass(event.target, "selected")
    }

    function addImageSliderEventListeners() {
        const slide = document.querySelector(".swym-custom-slider-image");
        nextButton.addEventListener("click", () => {
            const slideWidth = slide.clientWidth;
            imageSliderContainer.scrollLeft += slideWidth;
        });

        prevButton.addEventListener("click", () => {
            const slideWidth = slide.clientWidth;
            imageSliderContainer.scrollLeft -= slideWidth;
        });
    }

    function initializeSwipeableImageSlider() {
        let imageSlides = [];

        variantImagesArray.forEach((image, index) => {
            const imageSlide = document.createElement('img');
            imageSlide.src = image.src;
            imageSlide.ariaLabel = `product-image-${index}`;
            imageSlide.className = 'swym-custom-slider-image';
            imageSlide.width = '250';
            imageSlide.height = '250';
            imageSlide.addEventListener("click", showZoomedView);

            imageSlides.push(imageSlide);
            imageSliderContainer.appendChild(imageSlide);
        });

        addImageSliderEventListeners();
    }

    function addImageCarousel() {
        variantImagesArray = productData.product.images;
        initializeSwipeableImageSlider();
        const imgTags = variantImagesArray.map((image, index) => {
            const imgTag = document.createElement('img');
            imgTag.width = "24";
            imgTag.height = "24";
            imgTag.ariaLabel = `Product Secondary Image-${index}`;
            imgTag.id = `swym-custom-image-blob`;
            imgTag.src = image.src;

            imgTag.addEventListener("click", addImgBlobClickListener);

            return imgTag;
        });

        imgBlobContainer.innerHTML = '';
        imgBlobContainer.append(...imgTags);
    }

    function updateListHandler() {
        let listInputs = document.querySelectorAll(".swym-custom-list-button");
        globalActionArray = [];
        listInputs.forEach((input) => {
            if (!input.checked && input.classList.contains("variant-in-wishlist")) {
                globalActionArray.push({
                    actionType: 'remove',
                    listId: `${input.getAttribute("data-list-id")}`
                });

            } else if (input.checked && !input.classList.contains("variant-in-wishlist")) {
                globalActionArray.push({
                    actionType: 'add',
                    listId: `${input.getAttribute("data-list-id")}`
                });
            }
        });
        toggleAddToWishlistButtonState();
    }

    function isVariantPresentInLists() {
        if (!isSingleWishlist) {
            globalListArray.forEach((list) => {
                const listId = list.lid;
                const listInput = document.querySelector(`#swym-list-action-btn[list-id="${listId}"]`);
                const variantIsPresent = listInput && list.listcontents.some((variant) => variant.epi === currentVariantId);

                if (listInput) {
                    listInput.setAttribute("variantexistsinlist", variantIsPresent);
                    if (variantIsPresent) {
                        listInput.innerHTML = 'Remove';
                    } else {
                        listInput.innerHTML = 'Add';
                    }
                }
            });
        } else {
            const variantInWishlist = globalProductsInListArray.some((product) => product.epi === currentVariantId);

            addToWishlistButton.classList.toggle("variant-in-wishlist", variantInWishlist);
            addToWishlistButton.textContent = variantInWishlist ? _swat.retailerSettings.Strings.WishlistAddedCTA : _swat.retailerSettings.Strings.WishlistAddCTA;
        }
        toggleAddToWishlistButtonState();
    }

    function listSelectionEventlistener() {
        const listInputs = document.querySelectorAll(".swym-custom-list-button");
        listInputs.forEach((input) => {
            input.addEventListener("click", (e) => {
                if (e.target.classList.contains("selected")) {
                    e.target.classList.remove("selected");
                } else {
                    e.target.classList.add("selected");
                }
                updateListHandler();
            });
        });
        isVariantPresentInLists();
    }

    function addWishlists() {
        if (!isSingleWishlist) {
            multipleListParentContainer.classList.remove("swym-hide-container");
            createListButton.classList.remove("swym-hide-container");
            addToWishlistButton.innerHTML = "Done";

            const onSuccess = (lists) => {
                globalListArray = lists;
                const listItemsHTML = lists.map((list) => {
                    let variantExistsInList = list.listcontents.some(product => product.epi == currentVariantId);
                    return `
                    <div id="swym-list-action-wrapper" class="swym-global-font-family">
                        <div id="${list.lid}-${productData.product.id}" list-name="${list.lname}" aria-label="Select ${list.lname}" class="swym-custom-list-button" type="checkbox" data-list-id="${list.lid}">${list.lname} (${list.listcontents.length})</div>
                        <button list-id="${list.lid}" list-name="${list.lname}" onclick="performListAction(event)" id="swym-list-action-btn" variantExistsInList="${variantExistsInList}">${variantExistsInList ? 'Remove' : 'Add'}</button>
                    </div>`;
                }).join("");

                listIdContainer.innerHTML = listItemsHTML;

                listSelectionEventlistener();
                isVariantPresentInLists();

                if (globalListArray.length < 1) {
                    createListButton.click();
                }

                toggleVariantData();
            };

            const onError = (error) => customErrorHandling(error.description);

            swat.fetchLists({ callbackFn: onSuccess, errorFn: onError });
        } else if (isSingleWishlist) {
            swat.fetch((allWishlistedProducts) => {
                globalProductsInListArray = allWishlistedProducts;
                isVariantPresentInLists();
            }, (error) => customErrorHandling(error.description));

            toggleVariantData();
        }
    }

    function toggleVariantData() {
        getSelectedVariant(selectCallBackObj);

        const currentProductTitle = productData.product.title;
        const currentProductVendor = productData.product.vendor;
        const alterNateVariantImages = productData.product.images;
        const currentVariantTitle = selectedVariant.title.replace(/\//g, "");
        const currentVariantPrice = swat.currency+selectedVariant.price;
        const imageId = selectedVariant.image_id;

        vendorTitle.innerHTML = productData.metafieldData.product_sub_title;
        productTitle.innerHTML = currentProductTitle;
        variantTitle.innerHTML = currentVariantTitle;
        price.innerHTML = currentVariantPrice;

        for (let i = 0; i < alterNateVariantImages.length; i++) {
            if (alterNateVariantImages[i].id == imageId) {
                variantImage.setAttribute("src", alterNateVariantImages[i].src);
            } else {
                variantImage.setAttribute("src", productData.product.image.src);
            }
        }
    }

    function addProductData() {
        const product = productData.product;
        variantImage.src = product.image.src;
        vendorTitle.innerHTML = productData.metafieldData.product_sub_title;
        productTitle.innerHTML = product.title;
        mobileModalTitle.textContent = product.title;
        price.innerHTML = product.variants[0].price;

        addWishlists();
        addImageCarousel();
        renderVariantSelectors(productData);
        updateSoldOutVariants(productData.translatedProductData.variants);
    }

    function toggleAddToWishlistButtonState() {
        if (!isSingleWishlist) {
            if (globalActionArray.length === 0) {
                // addToWishlistButton.setAttribute("disabled", true);
                // addToWishlistButton.textContent = currentLanguageOption.addToWishlistTextNoListSelected;
            } else {
                const hasRemoveAction = globalActionArray.some((action) => action.actionType === 'remove');
                addToWishlistButton.removeAttribute("disabled");
                addToWishlistButton.textContent = hasRemoveAction ? currentLanguageOption.addToWishlistTextUpdateState : currentLanguageOption.addToWishlistTextAddState;
            }
        }
    }


    function updateVariantInLists() {
        const product = {
            epi: currentVariantId,
            empi: productData.product.id,
            du: productURL
        };

        if (!isSingleWishlist) {
            closeCollectionsModal();
        } else {
            handleSingleWishlist(product);
            setTimeout(closeCollectionsModal, 1000);
        }
    }

    function handleSingleWishlist(product) {
        let lid = window.currentActiveListId;

        let onSuccess = item => {};
        let onError = error => console.error("Error while modifying the Product on the List - ", error);

        !addToWishlistButton.classList.contains("variant-in-wishlist") ? swat.addToList(lid, product, customSuccessHandling, onError) : swat.deleteFromList(lid, product, onSuccess, onError);
    }

    function convertObjectToString(selectCallBackObj) {
        return Object.values(selectCallBackObj).join(" / ");
    }

    function getSelectedVariant(selectCallBackObj) {
        globalActionArray = [];
        const variants = productData.product.variants;
        let variantComboUnavailable = false;
        variants.forEach((variant) => {
            const filterTitle = convertObjectToString(selectCallBackObj);
            if (filterTitle == variant.title) {
                variantComboUnavailable = true;
                selectedVariant = variant;
                currentVariantId = variant.id;
            }
        });
        if (!variantComboUnavailable) {
            addToWishlistButton.setAttribute("disabled", true);
            addToWishlistButton.textContent = "Combination Unavailable";
        } else {
            addToWishlistButton.removeAttribute("disabled");
            addToWishlistButton.textContent = "Done";
        }

        isVariantPresentInLists();
    }

    function handleRadioButtonClick(event) {
        const selectedValue = event.target.value;
        const optionIndex = event.currentTarget.getAttribute("optionIndex");

        selectCallBackObj = {
            ...selectCallBackObj,
            [optionIndex]: selectedValue,
        };

        const labels = event.currentTarget.parentNode.querySelectorAll(
            `label[for="${event.target.id}"]`
        );
        labels.forEach((label) => {
            label.classList.add("selected");
        });

        const unselectedRadios = event.currentTarget.parentNode.querySelectorAll(
            `input[type="radio"]:not([value="${selectedValue}"])`
        );
        unselectedRadios.forEach((radio) => {
            const labels = event.currentTarget.parentNode.querySelectorAll(
                `label[for="${radio.id}"]`
            );
            labels.forEach((label) => {
                label.classList.remove("selected");
            });
        });

        toggleVariantData();
    }

    function createRadioGroup(option, optionIndex) {
        const variantOptions = option.values
            .map((value) => {
                const isSelected = value == selectedVariant[`option${optionIndex + 1}`];
                return `<input style="display: none;" selected="${isSelected}" id="${option.name}-${value}" type="radio" name="${option.name}" optionIndex="${optionIndex}" value="${value}" aria-label="${option.name} ${value}"></input>
                        <label data-option-value="${value.replace(/[\s\/]/g, '')}" class="swym-filter-labels" for="${option.name}-${value}">${value}</label>`;
            })
            .join("");

        const radioGroup = document.createElement("div");
        radioGroup.setAttribute("class", `${option.name} swym-filter-option-name`);
        const optionName = option.name.toLowerCase() == 'size' ? window.sizeTranslatedString : option.name;
        radioGroup.innerHTML = `<div id="swymOptionName" selected value="${option.name}">${optionName}</div>
                                  <div class="swym-radio-buttons-container">${variantOptions}</div>`;

        const radioButtons = radioGroup.querySelectorAll(`[name="${option.name}"]`);
        for (let i = 0; i < radioButtons.length; i++) {
            radioButtons[i].addEventListener("click", function (event) {
                handleRadioButtonClick(event, productData);
            });
        }

        return radioGroup;
    }

    function renderVariantSelectors() {
        const optionsArray = productData.product.options;
        const variantSelectors = optionsArray.map((option, optionIndex) => {
            return createRadioGroup(option, optionIndex);
        });

        variantSelectionContainer.innerHTML = '';
        variantSelectors.forEach((variantSelector) => {
            variantSelectionContainer.append(variantSelector);
        });

        variantSelectors.forEach((variantSelector) => {
            const radioButtons = variantSelector.querySelectorAll(
                'input[type="radio"]'
            );
            if (radioButtons.length > 0) {
                radioButtons[0].click();
            }
        });
    }

    function updateSoldOutVariants(variants){
        const radioButtonContainer = variantSelectionContainer.querySelector('.swym-radio-buttons-container');
        const soldOutVariants = variants.filter(variant => !variant.available);
        soldOutVariants.forEach(variant => {
            radioButtonContainer.querySelector(`[data-option-value="${variant.title.replace(/[\s\/]/g, '')}"]`).classList.add('swym-sold-out');
        });
    }

    function closeCollectionsModal() {
        selectCallBackObj = {};
        swymCollectionsModal.classList.add("swym-hide-container");
        webpageBody.classList.remove("swym-modal-active");
        imageSliderContainer.innerHTML = '';
        variantSelectionContainer.innerHTML = '';
        imgBlobContainer.innerHTML = '';
        listIdContainer.innerHTML = '';
    }

    function openCollectionsModal() {
        addProductData(productData);

        swymCollectionsModal.classList.remove("swym-hide-container");
        variantImage.addEventListener("click", showZoomedView);
        webpageBody.classList.add("swym-modal-active");
        globalActionArray = [];

        window.addEventListener("click", (event) => {
            if (event.target === swymCollectionsModal) {
                closeCollectionsModal();
            }
        });
        imageSliderContainer.scrollLeft = 0;
    }

    async function _fetchProductMetafieldsData(url){
        const sectionHtml=await(await fetch(`${url}?section_id=swym-translated-product-data`)).text();
        const metafieldData = new DOMParser().parseFromString(sectionHtml,"text/html").getElementById("swym-product-metafields-data").textContent;
        const translatedProductData = new DOMParser().parseFromString(sectionHtml,"text/html").getElementById("swym-translated-product-data").textContent;
        return {metafieldData, translatedProductData};
    }

    async function fetchProductDetails(event) {
        event.preventDefault();
        const rawUrl = event.currentTarget.getAttribute("data-product-url");
        productURL = rawUrl.split("?")[0];
        const shopifyProductEndpoint = productURL + ".json";
        let {metafieldData, translatedProductData} = await _fetchProductMetafieldsData(productURL);
        [metafieldData, translatedProductData] = [JSON.parse(metafieldData), JSON.parse(translatedProductData)];
        fetch(shopifyProductEndpoint)
        .then((res) => res.json())
        .then((productJson) => {
            productData = productJson;
            productData.metafieldData = metafieldData;
            productData.translatedProductData = translatedProductData;
            selectedVariant = productData.product.variants[0];
            openCollectionsModal();
        });
    }

    function isHotspotWishlistButton(button) {
        return button.dataset.hotspotWishlistButton === 'true';
    }

    function setWishlistButtonState(button, isAdded) {
        button.classList.toggle('swym-added', isAdded);
        button.dataset.action = isAdded ? 'remove' : 'add';
        button.dataset.variantInWishlist = isAdded ? 'true' : 'false';
    }

    function getHotspotSelectedRadio(button) {
        const productCard = button.closest('product-card');
        if (!productCard) return null;
        return productCard.querySelector('.hotspot-lookbook__variant-radio-grid input[type="radio"]:checked');
    }

    function updateHotspotWishlistButtonState(button) {
        const selectedRadio = getHotspotSelectedRadio(button);
        if (!selectedRadio) {
            button.classList.remove('swym-added');
            return;
        }

        button.dataset.variantId = selectedRadio.dataset.variantId;
        button.dataset.variantTitle = selectedRadio.dataset.variantTitle;
        button.dataset.image = selectedRadio.dataset.variantImage;

        if (button.dataset.hotspotWishlistInFlight) {
            return;
        }

        if (!window.currentActiveListId) {
            button.classList.remove('swym-added');
            button.dataset.variantInWishlist = 'false';
            button.dataset.action = 'add';
            return;
        }

        swat.fetchListDetails(
            { lid: window.currentActiveListId },
            (listDetails) => {
                const listItems = listDetails?.items ?? [];
                const variantInWishlist = listItems.some((product) => `${product.epi}` === `${selectedRadio.dataset.variantId}`);
                setWishlistButtonState(button, variantInWishlist);
            },
            (error) => console.error('Error while fetching wishlist details for hotspot variant', error)
        );
    }

    function refreshHotspotButtons() {
        const hotspotButtons = document.querySelectorAll('.swym-wishlist-collection-btn[data-hotspot-wishlist-button="true"]');
        if (!hotspotButtons || hotspotButtons.length === 0) return;
        hotspotButtons.forEach((btn) => {
            try {
                updateHotspotWishlistButtonState(btn);
            } catch (e) {
                console.error('Error refreshing hotspot button state', e);
            }
        });
    }

    function parseVariantInWishlist(button) {
        if (button.dataset.variantInWishlist === 'true') return true;
        if (button.dataset.variantInWishlist === 'false') return false;
        return null;
    }

    function attachHotspotRadioListeners() {
        document.addEventListener('change', (event) => {
            const target = event.target;
            if (!target.matches('.hotspot-lookbook__variant-radio-grid input[type="radio"]')) return;
            const button = target.closest('product-card')?.querySelector('.swym-wishlist-collection-btn[data-hotspot-wishlist-button="true"]');
            if (button) updateHotspotWishlistButtonState(button);
        });
    }

    async function handleHotspotWishlistButtonClick(event) {
        event.preventDefault();
        const button = event.currentTarget;
        const selectedRadio = getHotspotSelectedRadio(button);
        if (!selectedRadio) return;

        const activeListId = window.currentActiveListId;
        if (!activeListId) {
            customErrorHandling('No active wishlist list found.');
            return;
        }

        if (button.dataset.hotspotWishlistInFlight) {
            return;
        }

        event.stopImmediatePropagation();
        event.stopPropagation();

        selectedVariant = {
            title: selectedRadio.dataset.variantTitle.toLowerCase() === 'default title' ? '' : selectedRadio.dataset.variantTitle
        };
        variantImagesArray = [{ src: selectedRadio.dataset.variantImage }];
        productData = {
            product: {
                title: button.getAttribute('data-product-title')
            }
        };

        const product = {
            epi: selectedRadio.dataset.variantId,
            empi: button.getAttribute('data-product-id'),
            du: button.getAttribute('data-product-url')
        };

        const onRemoveSuccess = () => {
            delete button.dataset.hotspotWishlistInFlight;
            setWishlistButtonState(button, false);
        };

        const onAddSuccess = (item) => {
            delete button.dataset.hotspotWishlistInFlight;
            setWishlistButtonState(button, true);
            customSuccessHandling(item);
        };

        const onError = (error) => {
            delete button.dataset.hotspotWishlistInFlight;
            console.error('Error while modifying the Product on the List - ', error);
        };

        const variantInWishlist = parseVariantInWishlist(button);

        const executeListAction = (variantInWishlist) => {
            button.dataset.hotspotWishlistInFlight = 'true';
            if (!variantInWishlist) {
                swat.addToList(activeListId, product, onAddSuccess, onError);
            } else {
                swat.deleteFromList(activeListId, product, onRemoveSuccess, onError);
            }
        };

        if (variantInWishlist !== null) {
            executeListAction(variantInWishlist);
        } else {
            swat.fetchListDetails(
                { lid: activeListId },
                (listDetails) => {
                    const listItems = listDetails?.items || [];
                    const variantInWishlist = listItems.some((product) => `${product.epi}` === `${selectedRadio.dataset.variantId}`);
                    executeListAction(variantInWishlist);
                },
                (error) => console.error('Error while fetching wishlist details for hotspot variant', error)
            );
        }
    }

    async function addToListSingleVariant(event) {
        event.preventDefault();
        const button = event.currentTarget;

        const activeListId = window.currentActiveListId;

        if (!activeListId) {
            customErrorHandling('No active wishlist list found.');
            return;
        }

        selectedVariant = {
            title : button.getAttribute('data-variant-title').toLowerCase() == 'default title' ? '' : button.getAttribute('data-variant-title')
        }
        variantImagesArray = [{
            src: button.getAttribute('data-image')
        }]
        productData = {
            wishlistData : {
                'epi': button.getAttribute('data-variant-id'),
                'empi': button.getAttribute('data-product-id'),
                'du': button.getAttribute('data-product-url')
            },
            product: {
                title: button.getAttribute('data-product-title'),
            }
        };
        let onSuccess = () => {
            setWishlistButtonState(button, false);
        };

        let onError = error => console.error("Error while modifying the Product on the List - ", error);

        const onAddSuccess = (item) => {
            setWishlistButtonState(button, true);
            customSuccessHandling(item);
        };

        swat.fetchListDetails(
            { lid: activeListId },
            (listDetails) => {
                const listItems = listDetails?.items || [];
                const variantInWishlist = listItems.some((product) => `${product.epi}` === `${productData.wishlistData.epi}`);

                if (!variantInWishlist) {
                    swat.addToList(activeListId, productData.wishlistData, onAddSuccess, onError);
                } else {
                    swat.deleteFromList(activeListId, productData.wishlistData, onSuccess, onError);
                }
            },
            (error) => customErrorHandling(error.description)
        );
    }

    function observeSwymWishlistButtons() {
        if (!window.MutationObserver || window.swymWishlistButtonsObserver) return;

        window.swymWishlistButtonsObserver = new MutationObserver(debounce_leading((mutations) => {
            let shouldBind = false;
            for (const mutation of mutations) {
                for (const node of mutation.addedNodes) {
                    if (!(node instanceof HTMLElement)) continue;
                    if (node.matches?.('.swym-wishlist-collection-btn[data-event-added="false"]') || node.querySelector?.('.swym-wishlist-collection-btn[data-event-added="false"]')) {
                        shouldBind = true;
                        break;
                    }
                }
                if (shouldBind) break;
            }
            if (shouldBind) addEventListeners();
        }, 100));

        window.swymWishlistButtonsObserver.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }

    function addEventListeners() {
        arrayOfSwymCollectionsButtons = document.querySelectorAll(".swym-wishlist-collection-btn[data-event-added='false']");
        if (arrayOfSwymCollectionsButtons.length > 0) {
            for (let i = 0; i < arrayOfSwymCollectionsButtons.length; i++) {
                const wishlistButton = arrayOfSwymCollectionsButtons[i];
                wishlistButton.setAttribute('data-event-added', true);
                if (isHotspotWishlistButton(wishlistButton)) {
                    wishlistButton.addEventListener("click", debounce_leading(handleHotspotWishlistButtonClick, 500));
                    updateHotspotWishlistButtonState(wishlistButton);
                } else if (wishlistButton.dataset.singleVariant == "true") {
                    wishlistButton.addEventListener("click", debounce_leading(addToListSingleVariant, 500));
                } else {
                    wishlistButton.addEventListener("click", debounce_leading(fetchProductDetails, 500));
                }
                SwymUtils.addClass(wishlistButton, "swym-loaded");
            }
        }

        attachHotspotRadioListeners();

        if (!window.eventsAddedToVariantSelectorModal) {
            window.eventsAddedToVariantSelectorModal = true;
            modalCloseButton.addEventListener("click", closeCollectionsModal);
            addToWishlistButton.addEventListener("click", debounce_leading(updateVariantInLists, 500));
        }
        persistWishlistButtonsState();
    }

    function initializeSwymWishlistButtons() {
        addEventListeners();
        observeSwymWishlistButtons();
        // Ensure hotspot buttons are synced once Swym default list is ready
        refreshHotspotButtons();
    }

    document.addEventListener('swym:default-list-executed', debounce_leading(initializeSwymWishlistButtons, 0));
    document.addEventListener('DOMContentLoaded', debounce_leading(initializeSwymWishlistButtons, 0));
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
        debounce_leading(initializeSwymWishlistButtons, 0)();
    }
}

if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
}

window.SwymCallbacks.push(onSwymLoadCallback);